module.exports = __webpack_public_path__ + "static/img/hqms-2.eefe476.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hqms/hqms-2.png
// module id = K/f1
// module chunks = 1